import { useEffect, useState } from "react";
import { GET_ARCHIVE_ROLE_END_POINT } from "../../../config/config";
import { requirementsProps } from "../../../utils/types";

const ArchiveRoles = () => {

    const [roles, setRoles] = useState<requirementsProps | null>(null);

    useEffect(()=>{

    },[])

    return (
        <div>
            <div className="w-full bg-white px-2 py-4">
                <div>
                    <h1 className="text-md">
                    Archive Roles
                    </h1>
                </div>
            </div>
            <div className='table-container'>
                <table className="w-full border">
                    <thead className="table-fixed-header border">
                        <tr>
                            <th className='table-headers'>#</th>
                            <th className='table-headers'>Position Title</th>
                            <th className='table-headers'>Client</th>
                            <th className='table-headers'>Domain</th>
                            <th className='table-headers'>Segment</th>
                            <th className='table-headers'>Sub-Segment</th>
                            <th className='table-headers'>Action</th>
                        </tr>
                    </thead>
                    <tbody className="text-center">
                        
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default ArchiveRoles;
